import React, { useState } from "react";
import "./ItemImages.css";
import PostAPI from "../../APICalls/PostAPI";

const ItemImage = ({ chefID, menuData, handleAddClose, imageValue }) => {
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(imageValue ? imageValue : "N/A");

  const handleImageUpload = async (e) => {
    setLoading(true);
    const FILE = e.target.files[0];
    if (!FILE) {
      setLoading(false);
      return;
    }

    const fileType = "." + FILE.type.split("/")[1];
    const encoded = await getBase64(FILE);
    const splitArray = encoded.split("base64,");
    const updatedBase64Value = splitArray[1];

    const dataToPost = {
      userID: chefID,
      fileType: fileType,
      fileID: menuData.menuID,
      flag: "MENU",
      fileWithBase64: updatedBase64Value,
    };

    const ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
    let fileUploadApi = ENVIRONMENT === "PRODUCTION" || ENVIRONMENT === undefined
      ? process.env.REACT_APP_PROD_FILEUPLOAD
      : process.env.REACT_APP_DEV_FILEUPLOAD;

    try {
      const RESPONSE = await PostAPI(fileUploadApi, dataToPost);
      if (RESPONSE.data.statusCode === 200) {
        setImage(RESPONSE.data.body);
        handleAddClose();
        alert("Uploaded image successfully");
      } else {
        alert("Error uploading image, please try again");
      }
    } catch (e) {
      console.error(e);
      alert("Error uploading image, please try again");
    } finally {
      setLoading(false);
    }
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  return (
    <div className="item-image-container">
      {image?.toUpperCase() === "N/A" ?
      <h5 className="modal-title" style={{ color: "black", fontSize: "1.25rem", marginBottom: 5 }}>
      Upload image for {menuData.itemName}
    </h5>
      :
      <h5 className="modal-title" style={{ color: "black", fontSize: "1.25rem", marginBottom: 5 }}>
     Again Upload image for {menuData.itemName}
    </h5>
      }
      
      <div className="buttonEffect">
        <label htmlFor="input-file" className={loading ? "disabled-label" : ""}>
          {loading ? "Uploading..." : image?.toUpperCase() === "N/A" ? "Upload Image" : "Upload Image Again"}
        </label>
        <input
          type="file"
          id="input-file"
          onChange={handleImageUpload}
          disabled={loading}
          hidden
        />
      </div>
    </div>
  );
};

export default ItemImage;
